export class CertificadoDigitalFilter {
   public rut: string = "";
   public dv: string = "";
   public nombre: string = "";
   public emisorId: string;
   public activo: boolean;
   public EmisorRut: number;
}
